import { PageHero } from "../components/PageHero";
import { CtaBanner } from "../sections/CtaBanner";

const process = [
  {
    title: "Ungkep bumbu kuning",
    text: "Ayam pejantan direbus dalam bumbu ungkep kuning sampai gurihnya meresap — bukan sekadar menempel di kulit.",
  },
  {
    title: "Goreng sebentar",
    text: "Ayam digoreng sebentar saja begitu dipesan. Hasilnya: daging empuk yang tetap basah bumbu, bukan kering.",
  },
  {
    title: "Jukut goreng",
    text: "Sayuran digoreng hingga gurih renyah — pendamping khas yang jarang ditemui di luar Bandung.",
  },
  {
    title: "Sajikan panas",
    text: "Disajikan dengan nasi pulen hangat, lalapan, sambal goang beraroma kencur, dan sambal bawang yang nendang.",
  },
];

export default function TentangPage() {
  return (
    <div data-testid="tentang-page">
      <PageHero
        eyebrow="Tentang Bu Iyin"
        title="Dari konten kuliner, lahir sepiring ayam goreng basah."
        description="Cerita food vlogger asal Bandung yang mengubah kerinduannya pada masakan kampung halaman menjadi warung yang antreannya tak pernah sepi."
        crumbs={[
          { label: "Beranda", href: "/" },
          { label: "Tentang", href: "/tentang/" },
        ]}
      />

      <section className="mx-auto max-w-6xl px-5 py-14 sm:py-20" aria-label="Cerita kami">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="space-y-6 text-base leading-relaxed text-charcoal-muted lg:col-span-7">
            <p>
              Ayam Goreng Bu Iyin didirikan oleh{" "}
              <strong className="text-charcoal">Novianty Pratiwi</strong> — yang
              dikenal luas sebagai <strong className="text-charcoal">Inop</strong> —
              food vlogger yang konten ulasan makanannya viral di TikTok sejak
              masa pandemi. Setelah bertahun-tahun mencicipi dan mengulas makanan
              orang lain, Inop memulai bisnis kulinernya sendiri bersama sang
              suami.
            </p>
            <p>
              Menunya bukan pilihan acak. Sebagai orang Bandung asli, Inop
              kerap merindukan ayam goreng basah — sajian khas kota kelahirannya
              yang sulit ditemukan di Jakarta.
            </p>
            <blockquote className="border-l-4 border-bumbu bg-bumbu-light/50 py-4 pl-6 pr-4 font-heading text-lg font-bold italic leading-relaxed text-charcoal">
              “Aku orang Bandung, terus aku juga suka kangen sama makanan
              Bandung. Apalagi ayam goreng basah ini, di Jakarta tuh jarang kan
              yang kayak gini.”
              <footer className="mt-3 font-mono text-xs font-bold uppercase not-italic tracking-[0.2em] text-bumbu-deep">
                — Inop, pemilik, kepada detikFood
              </footer>
            </blockquote>
            <p>
              Perjalanan Bu Iyin dimulai dari sebuah kios sederhana di area
              kuliner Fresh Market Emerald Bintaro, Tangerang Selatan. Kios itu
              ramai setiap hari sampai pengunjung harus mengantre. Permintaan
              yang terus meningkat membawa Bu Iyin membuka gerai keduanya:
              sebuah area open space di Jl. Wijaya II No. 76, Melawai, Jakarta
              Selatan — lengkap dengan sistem antrean digital berbasis kode QR.
            </p>
            <p>
              Konsepnya sengaja dibuat sederhana: warung yang bersahaja, menu
              yang fokus, dan rasa yang jujur. Yang serius hanya satu — ayam
              goreng basah khas Bandung, dibuat dengan cara yang benar.
            </p>
          </div>

          <aside className="lg:col-span-5">
            <figure className="overflow-hidden rounded-lg border border-amber-900/15">
              <img
                src="/images/warung.webp"
                alt="Suasana dapur terbuka tempat makanan digoreng dan disajikan hangat"
                width="1200"
                height="800"
                loading="lazy"
                className="aspect-[3/2] w-full object-cover"
              />
            </figure>
            <div className="mt-6 rounded-lg border-2 border-dashed border-bumbu/50 bg-bumbu-light/40 p-6">
              <h2 className="font-heading text-lg font-extrabold text-charcoal">
                Warung sederhana, rasa yang serius.
              </h2>
              <p className="mt-2 text-sm leading-relaxed text-charcoal-muted">
                Tidak ada embel-embel berlebihan. Hanya ayam pejantan, bumbu
                ungkep kuning, jukut goreng, dan dua sambal — disajikan panas,
                harga bersahabat.
              </p>
            </div>
          </aside>
        </div>
      </section>

      <section className="bg-canvas-subtle py-16 sm:py-24" aria-label="Proses kami">
        <div className="mx-auto max-w-6xl px-5">
          <p className="font-mono text-xs font-bold uppercase tracking-[0.25em] text-bumbu">
            Dari Ungkep Sampai Piring
          </p>
          <h2 className="mt-3 font-heading text-3xl font-extrabold tracking-tight text-charcoal sm:text-4xl">
            Begini ayam basah kami dibuat.
          </h2>

          <ol className="mt-12 grid gap-px overflow-hidden rounded-lg border border-amber-900/15 bg-amber-900/15 sm:grid-cols-2 lg:grid-cols-4">
            {process.map((step, i) => (
              <li key={step.title} className="bg-white p-7">
                <span className="font-mono text-3xl font-bold text-bumbu">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <h3 className="mt-4 font-heading text-lg font-bold text-charcoal">
                  {step.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-charcoal-muted">
                  {step.text}
                </p>
              </li>
            ))}
          </ol>
        </div>
      </section>

      <CtaBanner />
    </div>
  );
}
